const getDateTimeFromISOstring = (
    value,
    options = {
        day: '2-digit', month: '2-digit', year: 'numeric', hour12: false,
        hour: 'numeric', minute: 'numeric', second: 'numeric',
    }) => {
    return value ? Intl.DateTimeFormat('it-IT', options).format(new Date(value)) : value;
}

export default getDateTimeFromISOstring;